// Track editor entry points, excluding links to read-only shared calendars.
exports.installAppClickTracking = function (win, doc) {
  if (win.__APP_CLICK_TRACKING_INSTALLED__) return;
  win.__APP_CLICK_TRACKING_INSTALLED__ = true;
  doc.addEventListener('click', event => {
    const link = event.target && event.target.closest && event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.button > 0) return;
    const url = new URL(link.href, win.location.href);
    if (url.origin !== 'https://app.schoolcalendar.me' || url.pathname !== '/') return;
    const params = {
      source_page: win.location.pathname,
      cta_location: win.location.pathname === '/' ? 'homepage' : 'guide',
    };
    const gtm = Boolean(win.__GOOGLE_TAG_MANAGER_ID__);
    if (!gtm && !(win.__GOOGLE_ANALYTICS_ID__ && win.gtag)) return;
    const sameTab = !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey &&
      (!link.target || link.target === '_self') && !link.hasAttribute('download');
    let navigated = false;
    const navigate = () => {
      if (!sameTab || navigated) return;
      navigated = true;
      win.location.assign(link.href);
    };
    if (sameTab) {
      event.preventDefault();
      // Always continue, including when tags are blocked or not configured yet.
      win.setTimeout(navigate, 800);
    }
    try {
      if (gtm) {
        win.dataLayer = win.dataLayer || [];
        win.dataLayer.push({ event: 'app_open_click', ...params,
          eventCallback: navigate, eventTimeout: 800 });
      } else {
        win.gtag('event', 'app_open_click', { ...params,
          send_to: win.__GOOGLE_ANALYTICS_ID__, event_callback: navigate,
          event_timeout: 800, transport_type: 'beacon' });
      }
    } catch (_) { navigate(); }
  });
};
